'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTheme = exports.hexToRgba = exports.addFontCss = undefined;

var _ThemeTemplate = require('./ThemeTemplate');

var FONT_ELEMENT_ID = 'cw_font_css';
var THEME_ELEMENT_ID = 'cw_theme_styles';

/**
 * Injects font link in <head>
 * @param {string} fontHref 
 */
var addFontCss = exports.addFontCss = function addFontCss() {
  var fontHref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'https://files.connectwise.com/UI/Styles/font.css';

  var link = document.getElementById(FONT_ELEMENT_ID);
  if (!link) {
    link = document.createElement('link');
    link.rel = 'stylesheet';
    link.id = FONT_ELEMENT_ID;
    document.head.appendChild(link);
  }

  link.href = fontHref;
};

/**
 * Converts HEX to RGB
 * @param {string} hex 
 * @param {number} [opacity] 0-100 percentage based
 */
var hexToRgba = exports.hexToRgba = function hexToRgba(hex) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? 'rgba(' + parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16) + ',' + opacity / 100 + ')' : 'rgba(0,0,0)';
};

/**
 * Injects theme style in <head>
 * Colors MUST be in HEX
 * @param {string} hexColor 
 * @param {string} [hexColor2] 
 * @param {string} [custom] 
 */
var setTheme = exports.setTheme = function setTheme(hexColor, hexColor2, custom) {
  // auto generate secondary color if not provided
  if (!hexColor2) {
    // convert color to rgb
    hexColor2 = hexToRgba(hexColor, 10);
  }

  var template = custom ? (0, _ThemeTemplate.getTemplate)() + custom : (0, _ThemeTemplate.getTemplate)();
  var result = template.replace(/primary/g, hexColor).replace(/secondary/g, hexColor2);

  var style = document.getElementById(THEME_ELEMENT_ID);
  if (!style) {
    style = document.createElement('style');
    style.type = 'text/css';
    style.id = THEME_ELEMENT_ID;
    document.head.insertBefore(style, document.head.firstChild);
  }

  style.innerHTML = result;
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/utils/ThemeService.js
// module id = 869
// module chunks = 10